import { useEffect, useRef } from "react";

const CURRENT_VERSION = "2.0.0";
const CHECK_INTERVAL = 5 * 60 * 1000; // Check every 5 minutes

export default function VersionCheck() {
  const hasReloaded = useRef(false);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`);
        if (!res.ok) return;
        const data = await res.json();
        if (data.version && data.version !== CURRENT_VERSION && !hasReloaded.current) {
          hasReloaded.current = true;
          // Force reload to get new assets
          window.location.reload();
        }
      } catch {
        // Silently fail — don't disrupt user experience
      }
    };

    // Check on mount (after brief delay to avoid blocking initial load)
    const initialCheck = setTimeout(checkVersion, 10000);
    // Then check periodically
    const interval = setInterval(checkVersion, CHECK_INTERVAL);

    return () => {
      clearTimeout(initialCheck);
      clearInterval(interval);
    };
  }, []);

  return null;
}
